// extracted by mini-css-extract-plugin
export default {"root":"StripePaymentAddress_root__-+3o-","formRow":"StripePaymentAddress_formRow__9lDrK","field":"StripePaymentAddress_field__mdaKh"};